<template>
    <b-card :title="title">
        <b-card-body>
            <b-form>
                <b-form-group
                    id="input-group-first_name"
                    label="First Name*:"
                    label-for="input-first_name"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        id="input-first_name"
                        readonly
                        v-model="model.first_name"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-last_name"
                    label="Last Name*:"
                    label-for="input-last_name"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        id="input-last_name"
                        readonly
                        v-model="model.last_name"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-email"
                    label="Email:"
                    label-for="input-email"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        id="input-email"
                        readonly
                        v-model="model.email"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Current Password"
                    name="current-password"
                    label-for="input-current-password"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        id="input-current-password"
                        type="password"
                        v-model="model.current_password"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    label="New Password"
                    name="password"
                    label-for="input-new-password"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        id="input-new-password"
                        type="password"
                        v-model="model.password"
                        :disabled="!verified"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    label="Retype Password"
                    type="password"
                    label-for="input-confirm-password"
                    label-class="font-weight-bold pt-0"
                    label-cols="3"
                >
                    <b-form-input
                        type="password"
                        v-model="model.password_confirmation"
                        id="input-confirm-password"
                        :disabled="!verified"
                    ></b-form-input
                ></b-form-group>

                <div class="text-right">
                    <b-button
                        class="my-4"
                        variant="primary"
                        :disabled="updating ? true : false"
                        @click="updatePassword"
                        >{{
                            updating
                                ? 'Changing Password...'
                                : 'Change Password'
                        }}</b-button
                    >
                </div>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
export default {
    name: 'ManagePassword',
    mixins: [popupMixins],
    data: () => ({
        model: {},
        updating: false,
    }),
    props: ['title'],
    computed: {
        user() {
            return this.$store.state.user
        },
        verified() {
            const _verified = this.$store.state.verified
            console.log('verified', _verified)
            return _verified
        },
    },
    watch: {
        'model.current_password': debounce(function (_pass) {
            this.$store.dispatch('checkPassword', _pass)
        }, 1000),
    },

    mounted() {
        this.$store.commit('VERIFY_PASSWORD', false)
        this.model = { ...this.$store.state.user }
        console.log('model', this.model)
    },

    methods: {
        async updatePassword() {
            try {
                this.updating = true
                const { current_password, password, password_confirmation } =
                    this.model

                if (
                    !password ||
                    password.length < 6 ||
                    password != password_confirmation
                )
                    throw new Error('Invalid Password')

                await this.$store.dispatch('changePassword', {
                    current_password,
                    password,
                    password_confirmation,
                })
                this.model = { ...this.$store.state.user }
                this.doToast('Success!', 'Password Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
